/* Shape Cast theme interactions */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveals ---- */
  var revealEls = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window && !reduced) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- presale spots counter ---- */
  var spots = document.querySelector('[data-spots]');
  if (spots) {
    var total = parseInt(spots.getAttribute('data-total'), 10) || 100;
    var reserved = parseInt(spots.getAttribute('data-reserved'), 10) || 0;
    var countEl = spots.querySelector('[data-spots-count]');
    var fillEl = spots.querySelector('[data-spots-fill]');
    var pct = Math.min(100, (reserved / total) * 100);

    var runSpots = function () {
      if (fillEl) fillEl.style.width = pct + '%';
      if (!countEl) return;
      if (reduced) { countEl.textContent = reserved; return; }
      var t0 = null, dur = 1800;
      var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
      var step = function (ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        countEl.textContent = Math.round(ease(p) * reserved);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    if ('IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { runSpots(); so.disconnect(); }
        });
      }, { threshold: 0.4 });
      so.observe(spots);
    } else { runSpots(); }
  }

  /* ---- hero typewriter status line ---- */
  var typeline = document.getElementById('scTypeline');
  if (typeline) {
    var lines = [
      '> generate "armored forest troll, game-ready"',
      '> rendering on local GPU ... done in 0:41',
      '> export troll_01.fbx  troll_01.glb  ✓',
      '> queue next model — unlimited remaining'
    ];
    if (reduced) {
      typeline.textContent = lines[0];
    } else {
      var li = 0, ci = 0;
      var typeTick = function () {
        var line = lines[li];
        if (ci <= line.length) {
          typeline.textContent = line.slice(0, ci);
          ci++;
          setTimeout(typeTick, 34);
        } else {
          setTimeout(function () {
            li = (li + 1) % lines.length; ci = 0; typeTick();
          }, 1700);
        }
      };
      typeTick();
    }
  }

  /* ---- sticky buy bar ---- */
  var bar = document.getElementById('scStickyBar');
  if (bar) {
    var onScroll = function () {
      var on = window.scrollY > window.innerHeight * 0.9;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
